import { ReactNode, useMemo } from 'react'
import cn from 'classnames'

import Board from 'src/icons/board.webp'
import Mushroom from 'src/icons/mushroom.gif'

import { ContentSteps } from 'src/lib/useStepFlow'
import {
    TextLandDe,
    TextLandEn,
    TextLandRo,
    TextLandFr,
    TextLandIt,
    TextLandPt,
    TextLandEl,
    TextLandSl,
} from './text-fourth-step'

import { useControlModal, ModalType } from '@rockstar/registration-component'
import { SignUp } from 'src/features/registration/SignUp'

import { textBtn } from './mock'
import styles from './styles.module.scss'
import { CustomButton } from '../../button/CustomButton'
import { TLang } from 'src/constants/langs'

type TProps = {
    onNext?: (step: ContentSteps) => void
    step?: ContentSteps
    lang: TLang
}

const textByLang: Record<string, ReactNode> = {
    ro: <TextLandRo />,
    de: <TextLandDe />,
    en: <TextLandEn />,
    fr: <TextLandFr />,
    it: <TextLandIt />,
    pt: <TextLandPt />,
    el: <TextLandEl />,
    sl: <TextLandSl />,
}

export const FourthStep = ({ lang }: TProps) => {
    const { modalType, setModalType } = useControlModal()

    const MODALS = useMemo<{ [key in ModalType]: ReactNode | null }>(
        () => ({
            sign_up: <SignUp language={lang} />,
            clear: null,
        }),
        [lang],
    )

    const renderTextContent = textByLang[lang] ?? <TextLandEn />

    const getBtnTextByLang = () => {
        const foundText = textBtn.find((item) => item.lang === lang)

        return foundText ? foundText.text : ''
    }

    return (
        <div
            className={cn(styles.root, styles[`root__${lang}`], styles.hello)}
            style={{ backgroundImage: `url(${Board})` }}
        >
            <div
                className={cn(styles.wrappper, {
                    [styles[`wrappper--${lang}`]]: lang === 'en',
                })}
            >
                <img
                    src={Mushroom}
                    alt="MushroomLeft"
                    className={cn(styles.mushroom, styles.mushroomLeft)}
                />
                <img
                    src={Mushroom}
                    alt="MushroomRight"
                    className={cn(styles.mushroom, styles.mushroomRight)}
                />
                <div
                    className={cn(styles.content_text_wrapper, {
                        [styles[`content_text_wrapper--${lang}`]]:
                            lang === 'en' ||
                            lang === 'es' ||
                            lang === 'ro' ||
                            lang === 'sl',
                    })}
                >
                    {renderTextContent}
                </div>
                <div
                    className={cn(
                        styles.wrapper_button,
                        styles[`wrapper_button--${lang}`],
                    )}
                    onClick={() => setModalType('sign_up')}
                >
                    <CustomButton
                        textBtn={getBtnTextByLang()}
                        classNames={{ textBtn: styles.text_btn }}
                    />
                </div>
            </div>
            {MODALS[modalType]}
        </div>
    )
}
